var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup619(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(0 -0.302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(0 0.302)",
    fill: "#73fe81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(2.9 2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M-535.029,119.9a.674.674,0,0,1-.515.66,6.209,6.209,0,0,0-1.582.775,6.023,6.023,0,0,0-2.636,4.177,6.153,6.153,0,0,0,4.169,6.827.709.709,0,0,1,.556.817.679.679,0,0,1-.909.514A7.46,7.46,0,0,1-538.811,132a7.43,7.43,0,0,1-2.307-4.334,7.555,7.555,0,0,1,5.16-8.408A.683.683,0,0,1-535.029,119.9Z",
    transform: "translate(541.217 -119.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M-257.5,126.092a7.615,7.615,0,0,1-5.229,7.375.681.681,0,0,1-.924-.413.685.685,0,0,1,.5-.885A6.078,6.078,0,0,0-259.124,128a6.182,6.182,0,0,0-3.961-7.6c-.422-.141-.6-.351-.594-.714a.661.661,0,0,1,.853-.639,7.2,7.2,0,0,1,2.538,1.352,7.464,7.464,0,0,1,2.693,4.673C-257.529,125.468-257.516,125.873-257.5,126.092Z",
    transform: "translate(272.633 -119.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M-386.091,261.6a2.742,2.742,0,0,1-2.744,2.74,2.741,2.741,0,0,1-2.747-2.752,2.74,2.74,0,0,1,2.743-2.74A2.74,2.74,0,0,1-386.091,261.6Zm-4.124-.007a1.4,1.4,0,0,0,1.373,1.38,1.394,1.394,0,0,0,1.384-1.369,1.4,1.4,0,0,0-1.381-1.388A1.4,1.4,0,0,0-390.215,261.6Z",
    transform: "translate(396.406 -254.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    d: "M-477.024,193.113a5.489,5.489,0,0,1,1.721-4.137,5.214,5.214,0,0,1,1.41-.974.681.681,0,0,1,.852.2.683.683,0,0,1-.034.861,1.062,1.062,0,0,1-.287.2,4.085,4.085,0,0,0-2.247,3.146,4.112,4.112,0,0,0,2.26,4.257.69.69,0,0,1,.444.663.677.677,0,0,1-.963.6,5.36,5.36,0,0,1-1.869-1.445,5.514,5.514,0,0,1-1.26-2.941C-477.013,193.4-477.015,193.258-477.024,193.113Z",
    transform: "translate(479.093 -185.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    d: "M-259.519,192.8a5.491,5.491,0,0,1-1.718,4.139,5.386,5.386,0,0,1-1.395.971.678.678,0,0,1-.933-.3.68.68,0,0,1,.321-.926,4.08,4.08,0,0,0,2.253-2.873,4.111,4.111,0,0,0-2.2-4.56.693.693,0,0,1-.437-.57.676.676,0,0,1,.991-.683,5.388,5.388,0,0,1,1.827,1.424,5.516,5.516,0,0,1,1.266,2.957C-259.528,192.521-259.527,192.662-259.519,192.8Z",
    transform: "translate(272.587 -185.704)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup619);
export default __webpack_public_path__ + "static/media/Group 619.cfd0029844691914f91bce50954d67a2.svg";
export { ForwardRef as ReactComponent };